import React from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { hasAccess, resources, access } from 'utils/permissions';
import { useRegionalLink } from 'hooks/useRegionalLink';

import classes from './SettingsLinks.module.scss';

const SettingsLinks = ({ newUrl }) => {
  const { t } = useTranslation('settings');
  const generateRegionalPath = useRegionalLink();

  return (
    <section className={classes.tabs}>
      {hasAccess([resources.SETTINGS_USERS, access.READ]) && (
        <NavLink
          className={classes.tabs_item}
          activeClassName={classes.tabs_item__active}
          to={generateRegionalPath(`${newUrl}/users`)}
        >
          {t('settings:tab.USERS')}
        </NavLink>
      )}

      {hasAccess([resources.SETTINGS_ROLES, access.READ]) && (
        <NavLink
          className={classes.tabs_item}
          activeClassName={classes.tabs_item__active}
          to={generateRegionalPath(`${newUrl}/roles`)}
        >
          {t('settings:tab.ROLES')}
        </NavLink>
      )}
    </section>
  );
};

SettingsLinks.propTypes = {
  newUrl: PropTypes.string.isRequired
};

export default SettingsLinks;
